import React from 'react'

import { StateProvider } from '../stores/share'
import ShareHistory from './Share/ShareHistory'

const EmptyState = () => {
  return (
    <>
      <p>No graphics posted yet.</p>
      <a class="btn btn-primary" href={`../graphics`}>
        Create Graphics to Share
      </a>
    </>
  )
}

export default function TeamShares(props) {
  return (
    <StateProvider {...props}>
      <ShareHistory title={props.title || 'All Posts & Shares'} emptyState={<EmptyState />} />
    </StateProvider>
  )
}
